import React, { useState, useEffect, useCallback } from "react";
import Header from "../components/Header";
import NavigationSidebar from "../components/Navigationsidebar/NavigationSidebar";
import BarChartViz01 from "../components/Dashboardviz/D03/DB03Viz1";
import BarChartViz03 from "../components/Dashboardviz/D03/DB03Viz3";
import BarChartViz04 from "../components/Dashboardviz/D03/DB03Viz4";
import Scatterplot01 from "../components/Dashboardviz/D03/DB03Viz2";
import FilterSidebar from "../components/FilterSidebar/FilterSidebar";
import { useFilter } from "../FilterContext";
import { FILTER_CONFIG } from "../config/filterconfig"; // Import centralized filter configuration
import jsonData from "../current-survey-numeric.json"; // Ensure the path is correct
import "./D03_Engagement_Summary.css";

const EngageSurveyDashboard = () => {
  const { filterCriteria } = useFilter();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isFilterSidebarOpen, setIsFilterSidebarOpen] = useState(false);
  const [filterOptions, setFilterOptions] = useState({});
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight
  });

  // Toggle navigation sidebar
  const toggleSidebar = useCallback(() => {
    setIsSidebarOpen((prev) => !prev);
  }, []);

  // Toggle filter sidebar
  const toggleFilterSidebar = useCallback(() => {
    setIsFilterSidebarOpen((prev) => !prev);
  }, []);

  // Window resize handler
  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    };

    window.addEventListener('resize', handleResize);
    
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // Chart resize handler
  useEffect(() => {
    const resizeCharts = () => {
      // If you're using ApexCharts
      if (window.ApexCharts) {
        const charts = document.querySelectorAll('.apexcharts-canvas');
        charts.forEach(chart => {
          try {
            chart.style.width = '100%';
            const chartInstance = window.ApexCharts.getChartByID(
              chart.closest('.apexchart-container')?.id
            );
            if (chartInstance) {
              chartInstance.updateOptions({
                chart: {
                  width: '100%'
                }
              });
            }
          } catch (e) {
            console.error("Chart resize error:", e);
          }
        });
      }
    };
    
    // Use a small delay to ensure DOM is ready
    const timer = setTimeout(resizeCharts, 100);
    
    return () => clearTimeout(timer);
  }, [windowSize]);

  useEffect(() => {
    const sortAlphabetically = (array) =>
      array.filter(Boolean).sort((a, b) => a.localeCompare(b));

    const generateFilterOptions = () => {
      const options = {};
      FILTER_CONFIG.forEach(({ fieldName, jsonKey, sortOrder }) => {
        let uniqueValues = [...new Set(jsonData.map((item) => item[jsonKey]))];
        uniqueValues = uniqueValues.filter((value) => value !== null);

        if (sortOrder) {
          uniqueValues = uniqueValues.sort(
            (a, b) => sortOrder.indexOf(a) - sortOrder.indexOf(b)
          );
        } else {
          uniqueValues = sortAlphabetically(uniqueValues);
        }

        options[fieldName] = uniqueValues;
      });

      return options;
    };

    setFilterOptions(generateFilterOptions());
  }, []);

  return (
    <div className="engagesurvey-dashboard-container">
      <Header
        title="Engagement Summary"
        toggleSidebar={toggleSidebar}
        toggleFilterSidebar={toggleFilterSidebar}
      />
      <NavigationSidebar
        isOpen={isSidebarOpen}
        className={
          isSidebarOpen
            ? "engagesurvey-sidebar-open"
            : "engagesurvey-sidebar-closed"
        }
      />
      <FilterSidebar
        isOpen={isFilterSidebarOpen}
        filterOptions={filterOptions}
        className={
          isFilterSidebarOpen
            ? "engagesurvey-filter-sidebar-open"
            : "engagesurvey-filter-sidebar-closed"
        }
      />
      <div className="engagesurvey-main-content">
        <div className="engagesurvey-content-wrapper">
          <div className="engagesurvey-charts-wrapper">
            <div className="engagesurvey-charts-container">
              <div className="engagesurvey-chart-card">
                <h2 className="engagesurvey-chart-title">Overall Engagement</h2>
                <div className="engagesurvey-chart-container">
                  <BarChartViz01 filterCriteria={filterCriteria} />
                </div>
              </div>
              <div className="engagesurvey-chart-card">
                <h2 className="engagesurvey-chart-title">
                  Engagement Areas Plotted by Impact
                </h2>
                <div className="engagesurvey-chart-container">
                  <Scatterplot01 filterCriteria={filterCriteria} />
                </div>
              </div>
              <div className="engagesurvey-chart-card">
                <h2 className="engagesurvey-chart-title">
                  Self-Reported Engagement
                </h2>
                <div className="engagesurvey-chart-container">
                  <BarChartViz03 filterCriteria={filterCriteria} />
                </div>
              </div>
              <div className="engagesurvey-chart-card">
                <h2 className="engagesurvey-chart-title">
                  Average Scores by Factor and Area
                </h2>
                <div className="engagesurvey-chart-container">
                  <BarChartViz04 filterCriteria={filterCriteria} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EngageSurveyDashboard;